var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICN-Car@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5,10 L6.5,5.5 L17.5,5.5 L19,10 L5,10 Z M17.5,15 C16.6715729,15 16,14.3284271 16,13.5 C16,12.6715729 16.6715729,12 17.5,12 C18.3284271,12 19,12.6715729 19,13.5 C19,14.3284271 18.3284271,15 17.5,15 L17.5,15 Z M6.5,15 C5.67157288,15 5,14.3284271 5,13.5 C5,12.6715729 5.67157288,12 6.5,12 C7.32842712,12 8,12.6715729 8,13.5 C8,14.3284271 7.32842712,15 6.5,15 L6.5,15 Z M18.92,5 C18.72,4.42 18.16,4 17.5,4 L6.5,4 C5.84,4 5.28,4.42 5.08,5 L3,11 L3,19 C3,19.5522847 3.44771525,20 4,20 L5,20 C5.55228475,20 6,19.5522847 6,19 L6,18 L18,18 L18,19 C18,19.5522847 18.4477153,20 19,20 L20,20 C20.5522847,20 21,19.5522847 21,19 L21,11 L18.92,5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Apply-Accelerate-\\uD83C\\uDFCE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icon",
    transform: "translate(-3.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#757575",
    fillOpacity: 0.87
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.6c2c90730d48c588bd311db731fa744e.svg";
export { ForwardRef as ReactComponent };